import { api } from '@/api.js';
import { config } from '@/config.js';
import { useDocumentDownload } from '@/composables/admin/documentos/useDocumentDownload';

/**
 * Fetcher y composable de descarga de documentos para abonados.
 *
 * GET /api1/abonados/{abonado_id}/documento/{documento_id}/descargar
 * Same-origin (nuestro backend) → sin CORS, auth via wrapper `api`.
 *
 * Gotcha: si el archivo no existe en ninguno de los dos discos, el
 * resource devuelve `documento.url` en null y el composable aborta
 * antes con toast.
 *
 * @returns {{ download: Function, loading: Ref<boolean> }}
 */
export function useAbonadoDocumentDownload() {
    async function abonadoFetcher(documento, abonadoId) {
        if (!abonadoId) {
            throw new Error('No se pudo identificar el abonado del documento.');
        }
        return api.call(
            config.getAPIRoute('back.abonados.descargar.documento'),
            {
                filters: {},
                abonado_id: abonadoId,
                documento_id: documento.id,
            },
            { responseType: 'blob' }
        );
    }

    return useDocumentDownload(abonadoFetcher);
}